export default __webpack_public_path__ + "static/media/bg.ada5b2a5.png";